import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { Published } from '../Core/PathItems'

export class CreateHealthCheckItem extends RequestOperation<CreateHealthCheckItemInput,HealthCheckItem> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Health.CreateHealthCheckItem",
      "CREATE",
      ["HealthCheckItemId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetAllHealthCheckItems extends RequestOperation<object,HealthCheckItem[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Health.GetAllHealthCheckItems",
      "GET",
      ["HealthCheckItemId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeleteHealthCheckItem extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Health.DeleteHealthCheckItem",
      "DELETE",
      ["HealthCheckItemId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateHealthCheckItemName extends MessageOperation<UpdateHealthCheckItemNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Health.UpdateHealthCheckItemName",
      "PATCH",
      ["HealthCheckItemId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdateHealthCheckItemState extends MessageOperation<UpdateHealthCheckItemStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Health.UpdateHealthCheckItemState",
      "PATCH",
      ["HealthCheckItemId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type CreateHealthCheckItemInput = {
  healthCheckItemId?: string | undefined
  name: string
}

export type HealthCheckItem = {
  id: string
  name: string
  translationKey: string
  state: Published
}

export type UpdateHealthCheckItemNameInput = {
  name: string
}

export type UpdateHealthCheckItemStateInput = {
  /**
   * Valid values: publish, unpublish, revert
   */
  stateTransition: string
}

